var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background"},[_c('Viewer25D',{attrs:{"imageOriginal":_vm.entrypoint+'/image_galleries/5ee3257caa59aa006d6631e3.2/display.jpeg',"imageDepth":"@/assets/img/grayscale.jpg","horizontalThreshold":25,"verticalThreshold":25}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }